export default {"src":"/_next/static/media/cart-white.fe88237a.svg","height":48,"width":56};